import { Controller } from "@hotwired/stimulus"
import SignaturePad from "signature_pad"

export default class extends Controller {
  static targets = ["canvas", "input", "wrapper"]

  connect() {
    this.pad = new SignaturePad(this.canvasTarget, {
      penColor: "#1a3a6b",
      backgroundColor: "rgba(255,255,255,0)"
    })
    this.resize()
    this._resizeHandler = () => this.resize()
    window.addEventListener("resize", this._resizeHandler)
    this._submitHandler = (event) => this.syncOnSubmit(event)
    if (this.element.form) {
      this.element.form.addEventListener("submit", this._submitHandler)
    } else {
      const form = this.element.closest("form")
      if (form) {
        this._form = form
        form.addEventListener("submit", this._submitHandler)
      }
    }
  }

  disconnect() {
    if (this._resizeHandler) window.removeEventListener("resize", this._resizeHandler)
    if (this._form && this._submitHandler) this._form.removeEventListener("submit", this._submitHandler)
  }

  resize() {
    const ratio = Math.max(window.devicePixelRatio || 1, 1)
    const canvas = this.canvasTarget
    const data = this.pad.toData()
    canvas.width = canvas.offsetWidth * ratio
    canvas.height = canvas.offsetHeight * ratio
    canvas.getContext("2d").scale(ratio, ratio)
    this.pad.clear()
    if (data && data.length) this.pad.fromData(data)
  }

  clear(event) {
    if (event) event.preventDefault()
    this.pad.clear()
    if (this.hasInputTarget) this.inputTarget.value = ""
  }

  syncOnSubmit(event) {
    if (this.pad.isEmpty()) {
      event.preventDefault()
      alert("Please draw your signature in the box before submitting.")
      this.canvasTarget.focus()
      return false
    }
    if (this.hasInputTarget) {
      this.inputTarget.value = this.pad.toDataURL("image/png")
    }
  }
}
